import { render, staticRenderFns } from "./supplierSelector.vue?vue&type=template&id=169c8c9c&scoped=true&"
import script from "./supplierSelector.vue?vue&type=script&lang=js&"
export * from "./supplierSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169c8c9c",
  null
  
)

export default component.exports